// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Existing styles */

/* General Styles */
.practitioner-list {
    padding: 2rem;
}

.practitioner-list .filters {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.practitioner-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1.5rem;
}

.practitioner-card {
    background-color: var(--clr-white);
    padding: 1.5rem;
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
    transition: var(--transition);
}

.practitioner-card:hover {
    box-shadow: var(--dark-shadow);
}

.card-content h4 {
    color: var(--clr-primary-5);
    margin-bottom: 0.5rem;
}

.card-content p {
    color: var(--clr-grey-3);
    margin-bottom: 0.5rem;
}

.no-practitioner-card {
    text-align: center;
    background-color: var(--clr-white);
    padding: 2rem;
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
}

/* Filters and Updating Fields Sections */
.filters-section,
.updating-fields {
    margin-bottom: 2rem;
    padding: 1.5rem;
    background-color: var(--clr-grey-10);
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
}

.filters-section h4,
.updating-fields h4 {
    margin-bottom: 1rem;
    color: var(--clr-primary-5);
    font-size: 1.25rem;
}

/* Add spacing between fields */
.filters-section select,
.updating-fields .name-fields,
.updating-fields select,
.updating-fields input {
    margin-bottom: 1rem; 
}

/* Name Fields Container */
.name-fields {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;
}

.name-fields input {
    flex: 1 1; /* Ensure all fields take equal space */
    padding: 0.75rem;
    border: 1px solid var(--clr-grey-6);
    border-radius: var(--radius);
    font-size: 1rem;
    color: var(--clr-grey-3);
    box-sizing: border-box; 
}

/* Load Practitioner by Name Button: Small Fit */
.name-fields button {
    padding: 0.5rem 1rem; 
    background-color: var(--clr-grey-5);
    color: var(--clr-white);
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    transition: var(--transition);
    font-size: 0.875rem; 
    width: auto; 
    display: inline-block; 
}

.name-fields button:hover {
    background-color: var(--clr-grey-4);
    box-shadow: var(--light-shadow);
}

/* Remove Practitioner Button: Large Fit */
.remove-btn {
    padding: 0.75rem 2rem; 
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    transition: var(--transition);
    font-size: 1rem; 
    /* width: 100%;  */
    display: block; 
}

.remove-btn:hover {
    background-color: var(--clr-primary-4);
    box-shadow: var(--dark-shadow);
}

/* Button container to align buttons side by side */
.button-container {
    display: flex;
    justify-content: space-between;
    gap: 1rem; 
    margin: 0 auto; 
}

/* Unique class for Add Practitioner button */
.add-practitioner-btn, .cancel-practitioner-btn {
    padding: 0.75rem 1.5rem;
    border-radius: 50px; 
    cursor: pointer;
    transition: var(--transition);
    font-size: 1rem;
    text-align: center;
}

/* Add Practitioner button specific styles */
.add-practitioner-btn {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    border: none;
}

.add-practitioner-btn:hover {
    background-color: var(--clr-primary-4);
    box-shadow: var(--dark-shadow);
}

/* Cancel button specific styles */
.cancel-practitioner-btn {
    background-color: var(--clr-grey-5);
    color: var(--clr-white);
    border: none;
}

.cancel-practitioner-btn:hover {
    background-color: var(--clr-grey-6);
    box-shadow: var(--dark-shadow);
}

/* Responsive styles for mobile */
@media (max-width: 768px) {
    .button-container {
        flex-direction: column; 
        gap: 0.5rem;
    }

    .add-practitioner-btn, .cancel-practitioner-btn {
        width: 100%; 
    }
}


/* Additional Fields for Email, Phone, and Experience */
.updating-fields input[type="email"],
.updating-fields input[type="text"],
.updating-fields input[type="number"] {  
    width: 100%; 
    padding: 0.75rem;
    border: 1px solid var(--clr-grey-6);
    border-radius: var(--radius);
    font-size: 1rem;
    color: var(--clr-grey-3);
    box-sizing: border-box; 
}

/* Label and Input on the Same Line */
.label-input-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
}

.label-input-container label {
    font-size: 1rem;
    color: var(--clr-grey-5);
    flex: 0.3 1; 
}

.label-input-container input {
    flex: 0.7 1; 
    padding: 0.75rem;
    border: 1px solid var(--clr-grey-6);
    border-radius: var(--radius);
    font-size: 1rem;
    color: var(--clr-grey-3);
    box-sizing: border-box;
}

/* Error Message Styling */
.error {
    color: var(--red-dark);
    font-size: 0.875rem;
    margin-top: 0.25rem;
}

/* Field Validation */
/* Remove red border by default until user interacts */
input:invalid:not(:focus):not(:placeholder-shown) {
    border-color: var(--clr-grey-6); 
}

input:invalid:focus {
    border-color: var(--red-dark); 
}

/* input:valid {
    border-color: var(--green-dark); 
} */

/* Success Banner */
.success-banner {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    padding: 1rem;
    border-radius: var(--radius);
    margin-bottom: 1rem;
    text-align: center;
}

/* License Expiry Styling */
input[type="date"] {
    padding: 0.75rem;
    border: 1px solid var(--clr-grey-6);
    border-radius: var(--radius);
    font-size: 1rem;
    color: var(--clr-grey-3);
    width: 100%; 
    box-sizing: border-box;
}

/* Responsive Success Banner */
@media (max-width: 768px) {
    .success-banner {
        font-size: 0.875rem;
    }
}

/* Responsive Design */
@media (max-width: 768px) {
    .practitioner-list {
        padding: 1rem;
    }

    .practitioner-card {
        padding: 1rem;
        margin-bottom: 1rem;
    }

    .card-content h4 {
        font-size: 1rem;
    }

    .card-content p {
        font-size: 0.875rem;
    }

    .no-practitioner-card {
        padding: 1.5rem;
    }

    .filters-section h4,
    .updating-fields h4 {
        font-size: 1rem;
    }

    .filters-section,
    .updating-fields {
        padding: 1rem;
    }

    .filters-section .name-fields,
    .filters-section select,
    .filters-section input,
    .name-fields select,
    .name-fields input {
        padding: 0.5rem;
        font-size: 0.875rem;
    }

    .updating-fields input[type="email"],
    .updating-fields input[type="text"],
    .updating-fields input[type="number"] { 
        padding: 0.5rem;
        font-size: 0.875rem;
    }

    .name-fields {
        flex-direction: column; 
    }

    .name-fields button {
        font-size: 0.75rem;
        padding: 0.5rem;
        width: auto; 
        display: inline-block;
    }

    .remove-btn {
        font-size: 0.875rem;
        padding: 0.75rem;
        width: 100%;
        display: block;
    }

    /* Label and Input on the Same Line (Responsive) */
    .label-input-container {
        flex-direction: column; 
    }

    .label-input-container label,
    .label-input-container input {
        flex: 1 1; 
    }
}

@media (max-width: 480px) {
    .practitioner-grid {
        grid-template-columns: 1fr; 
    }

    .practitioner-list {
        padding: 0.5rem;
    }

    .practitioner-card {
        padding: 0.75rem;
    }

    .card-content h4 {
        font-size: 0.875rem;
    }

    .card-content p {
        font-size: 0.75rem;
    }

    .no-practitioner-card {
        padding: 1rem;
    }

    .filters-section h4,
    .updating-fields h4 {
        font-size: 0.875rem;
    }

    .filters-section,
    .updating-fields {
        padding: 0.75rem;
    }

    .filters-section .name-fields,
    .filters-section select,
    .filters-section input,
    .name-fields select,
    .name-fields input {
        padding: 0.5rem;
        font-size: 0.75rem;
    }

    .updating-fields input[type="email"],
    .updating-fields input[type="text"],
    .updating-fields input[type="number"] {  
        padding: 0.5rem;
        font-size: 0.75rem;
    }

    .name-fields button {
        font-size: 0.75rem;
        padding: 0.5rem;
        width: auto;
        display: inline-block;
    }

    .remove-btn {
        font-size: 0.875rem;
        padding: 0.75rem;
        width: 100%;
        display: block;
    }
}

/* Banner Styles */
.mandatory-fields-banner {
    background-color: #fff3f3; 
    color: #d9534f; 
    padding: 5px 10px; 
    margin-bottom: 10px; 
    border: 1px solid #f2dede; 
    border-radius: 5px; 
    font-size: 0.9rem; 
}

.mandatory {
    color: #d9534f; /* Color for the asterisk */
}

/* Heading Styles */
.add-practitioner-title {
    font-size: 1.5rem; 
    font-weight: 600; 
    color: var(--clr-primary-4); 
    margin-bottom: 15px; 
    text-align: center; 
    border-bottom: 2px solid var(--red-light); 
    padding-bottom: 10px; 
}

/* Dropdown Container */
.dropdown-container {
    display: flex;
    gap: 20px; 
    justify-content: space-between;
    flex-wrap: wrap; 
  }
  
  /* Style for individual dropdowns */
  .dropdown-container select {
    flex: 1 1; 
    padding: 10px; 
    border-radius: 4px;
    border: 1px solid #ccc;
    box-sizing: border-box; 
  }
  
  /* Media Query for Mobile View (Max width 768px for tablets and phones) */
  @media (max-width: 768px) {
    .dropdown-container {
      flex-direction: column; 
      gap: 10px; 
    }
  
    .dropdown-container select {
      width: 100%; 
    }
  }
  

/* Input Container for the two fields */
.input-container {
    display: flex;
    gap: 20px; 
    justify-content: space-between;
    flex-wrap: wrap; 
  }
  
  .input-container input {
    flex: 1 1; 
    padding: 10px; 
    border-radius: 4px;
    border: 1px solid #ccc;
    box-sizing: border-box; 
  }
  
  /* Media Query for Mobile View (Max width 768px) */
  @media (max-width: 768px) {
    .input-container {
      flex-direction: column; 
      gap: 10px; 
    }
  
    .input-container input {
      width: 100%; 
    }
  }
  

/* Container for degree input */
.degree-input-container {
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5rem;
    border: 1px dotted var(--clr-grey-5); 
    border-radius: var(--radius); 
    padding: 1rem; 
    background-color: var(--clr-grey-10); 
}

/* Wrapper for the list and input sections */
.degree-input-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

/* Degree tags list */
.degrees-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    padding-bottom: 0.5rem;
}

/* Individual degree tag */
.degree-tag {
    background-color: var(--clr-primary-6);
    color: var(--clr-white);
    padding: 0.3rem;
    border-radius: var(--radius);
    display: inline-flex;
    align-items: center;
}

.degree-tag button {
    background: none;
    border: none;
    color: var(--clr-white);
    cursor: pointer;
    margin-left: 0.5rem;
}

.degree-tag button:hover {
    color: var(--clr-primary-1);
}

/* Input and Add button section */
.degree-input-section {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

/* Input for entering new degrees */
.degree-input {
    flex-grow: 1;
    padding: 0.75rem;
    border: 1px solid var(--clr-grey-6);
    border-radius: var(--radius);
    font-size: 1rem;
}

/* Add degree button */
.add-degree-btn {
    padding: 0.75rem 1rem;
    background-color: var(--clr-grey-6);
    color: var(--clr-white);
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    transition: var(--transition);
    font-size: 1rem;
}

.add-degree-btn:hover {
    background-color: var(--clr-primary-4);
    box-shadow: var(--dark-shadow);
}

/* Responsive styling */
@media (max-width: 768px) {
    .degree-input-section {
        flex-direction: column; 
        gap: 0.75rem; 
    }

    .add-degree-btn {
        width: 100%; 
    }

    .degree-tag {
        font-size: 0.85rem; 
    }
}

@media (max-width: 480px) {
    .degree-tag {
        font-size: 0.75rem; 
        padding: 0.5rem;
    }

    .degree-input-section {
        gap: 0.5rem; 
    }
}

.load-btn {
    background: var(--clr-primary-6);
    color: var(--clr-primary-1);
    padding: 0.375rem 0.75rem;
    font-weight: 700;
    transition: var(--transition);
    font-size: 0.875rem;
    border: 2px solid transparent;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    border-radius: var(--radius);

  }
  
  .load-btn:hover {
    text-decoration: underline;
  }


  /* Staff Add - Registration Status - Radio Buttons */
.staff-add-registration-radio-group {
    margin-bottom: 15px;
}

.staff-add-radio-title {
    font-weight: bold;
    color: #333;
    margin-bottom: 6px;
    display: block;
}

.staff-add-radio-options {
    display: flex;
    gap: 15px;
}

.staff-add-radio-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 1rem;
    color: #444;
}

.staff-add-radio-label input {
    transform: scale(1.2);
    cursor: pointer;
}

/* Base Styling for Inputs */
.staff-add-license-input,
.staff-add-license-expiry,
.staff-add-region-dropdown {
    width: 100%;
    padding: 8px;
    font-size: 14px;
    border-radius: 4px;
    transition: all 0.3s ease-in-out;
}

/* Disabled Fields (When Not Registered) */
.staff-add-license-input.disabled,
.staff-add-license-expiry.disabled {
    background-color: #f3f3f3;
    border: 1px dashed #999;
    opacity: 0.6;
    cursor: not-allowed;
}

/* Enabled Fields (When Registered) */
.staff-add-license-input.enabled,
.staff-add-license-expiry.enabled,
.staff-add-region-dropdown.enabled {
    background-color: #ffffff;
    border: 1px solid #ccc;
    cursor: text;
}

/* Cursor Pointer for Dropdown */
.staff-add-region-dropdown {
    cursor: pointer;
}

/* Helper Text */
.staff-add-helper-text {
    font-size: 0.9rem;
    color: #777;
    margin-top: 4px;
    font-style: italic;
}

/* Reset flex overrides only for phone field */
.label-input-container.phone-fix-override {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem;
    margin-bottom: 1rem;
  }
  
  /* Phone input row with prefix and input */
  .phone-input-split-add {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 0.5rem;
  }
  
  /* Non-editable +1 prefix */
  .phone-prefix-add {
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    padding: 0.5rem 0.75rem;
    border-radius: 4px;
    color: #333;
    font-weight: 500;
    min-width: 48px;
    text-align: center;
  }
  
  /* Phone input field itself */
  .phone-input-split-add input {
    flex: 1 1;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1rem;
  }
  
  @media (max-width: 768px) {
    .phone-input-split-add {
      flex-direction: row; /* keep row even on mobile */
      gap: 0.5rem;
    }
  
    .phone-input-split-add input {
      width: 100%;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/staffPortal/staffManage.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB,mBAAmB;AACnB;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA,yCAAyC;AACzC;;IAEI,mBAAmB;IACnB,eAAe;IACf,oCAAoC;IACpC,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;;IAEI,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA,+BAA+B;AAC/B;;;;IAII,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO,EAAE,uCAAuC;IAChD,gBAAgB;IAChB,mCAAmC;IACnC,4BAA4B;IAC5B,eAAe;IACf,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA,gDAAgD;AAChD;IACI,oBAAoB;IACpB,mCAAmC;IACnC,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,+BAA+B;AACnC;;AAEA,0CAA0C;AAC1C;IACI,qBAAqB;IACrB,sCAAsC;IACtC,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA,mDAAmD;AACnD;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;AAClB;;AAEA,6CAA6C;AAC7C;IACI,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;AACtB;;AAEA,4CAA4C;AAC5C;IACI,sCAAsC;IACtC,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA,kCAAkC;AAClC;IACI,mCAAmC;IACnC,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,8BAA8B;AAClC;;AAEA,iCAAiC;AACjC;IACI;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;;AAGA,uDAAuD;AACvD;;;IAGI,WAAW;IACX,gBAAgB;IAChB,mCAAmC;IACnC,4BAA4B;IAC5B,eAAe;IACf,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,WAAS;AACb;;AAEA;IACI,WAAS;IACT,gBAAgB;IAChB,mCAAmC;IACnC,4BAA4B;IAC5B,eAAe;IACf,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA,0BAA0B;AAC1B;IACI,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB,sDAAsD;AACtD;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;GAEG;;AAEH,mBAAmB;AACnB;IACI,sCAAsC;IACtC,uBAAuB;IACvB,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,mCAAmC;IACnC,4BAA4B;IAC5B,eAAe;IACf,wBAAwB;IACxB,WAAW;IACX,sBAAsB;AAC1B;;AAEA,8BAA8B;AAC9B;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;;;;;QAKI,eAAe;QACf,mBAAmB;IACvB;;IAEA;;;QAGI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,WAAW;QACX,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,WAAW;QACX,cAAc;IAClB;;IAEA,kDAAkD;IAClD;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,SAAO;IACX;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;;;;QAKI,eAAe;QACf,kBAAkB;IACtB;;IAEA;;;QAGI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,WAAW;QACX,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,WAAW;QACX,cAAc;IAClB;AACJ;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc,EAAE,2BAA2B;AAC/C;;AAEA,mBAAmB;AACnB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,oBAAoB;AACxB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,eAAe;EACjB;;EAEA,mCAAmC;EACnC;IACE,SAAO;IACP,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA,yEAAyE;EACzE;IACE;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,WAAW;IACb;EACF;;;AAGF,uCAAuC;AACvC;IACI,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA,kDAAkD;EAClD;IACE;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,WAAW;IACb;EACF;;;AAGF,+BAA+B;AAC/B;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,oCAAoC;IACpC,4BAA4B;IAC5B,aAAa;IACb,oCAAoC;AACxC;;AAEA,4CAA4C;AAC5C;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,sBAAsB;AAC1B;;AAEA,0BAA0B;AAC1B;IACI,sCAAsC;IACtC,uBAAuB;IACvB,eAAe;IACf,4BAA4B;IAC5B,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA,mCAAmC;AACnC;IACI,YAAY;IACZ,gBAAgB;IAChB,mCAAmC;IACnC,4BAA4B;IAC5B,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,qBAAqB;IACrB,mCAAmC;IACnC,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA,uBAAuB;AACvB;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;IAEhB,6BAA6B;IAC7B,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,wCAAwC;IACxC,4BAA4B;;EAE9B;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA,oDAAoD;AACtD;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA,4BAA4B;AAC5B;;;IAGI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA,0CAA0C;AAC1C;;IAEI,yBAAyB;IACzB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA,qCAAqC;AACrC;;;IAGI,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;AAChB;;AAEA,gCAAgC;AAChC;IACI,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA,8CAA8C;AAC9C;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;EACrB;;EAEA,0CAA0C;EAC1C;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;EACb;;EAEA,2BAA2B;EAC3B;IACE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA,6BAA6B;EAC7B;IACE,SAAO;IACP,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE;MACE,mBAAmB,EAAE,4BAA4B;MACjD,WAAW;IACb;;IAEA;MACE,WAAW;IACb;EACF","sourcesContent":["/* Existing styles */\n\n/* General Styles */\n.practitioner-list {\n    padding: 2rem;\n}\n\n.practitioner-list .filters {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.practitioner-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 1.5rem;\n}\n\n.practitioner-card {\n    background-color: var(--clr-white);\n    padding: 1.5rem;\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n    transition: var(--transition);\n}\n\n.practitioner-card:hover {\n    box-shadow: var(--dark-shadow);\n}\n\n.card-content h4 {\n    color: var(--clr-primary-5);\n    margin-bottom: 0.5rem;\n}\n\n.card-content p {\n    color: var(--clr-grey-3);\n    margin-bottom: 0.5rem;\n}\n\n.no-practitioner-card {\n    text-align: center;\n    background-color: var(--clr-white);\n    padding: 2rem;\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n}\n\n/* Filters and Updating Fields Sections */\n.filters-section,\n.updating-fields {\n    margin-bottom: 2rem;\n    padding: 1.5rem;\n    background-color: var(--clr-grey-10);\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n}\n\n.filters-section h4,\n.updating-fields h4 {\n    margin-bottom: 1rem;\n    color: var(--clr-primary-5);\n    font-size: 1.25rem;\n}\n\n/* Add spacing between fields */\n.filters-section select,\n.updating-fields .name-fields,\n.updating-fields select,\n.updating-fields input {\n    margin-bottom: 1rem; \n}\n\n/* Name Fields Container */\n.name-fields {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 1rem;\n}\n\n.name-fields input {\n    flex: 1; /* Ensure all fields take equal space */\n    padding: 0.75rem;\n    border: 1px solid var(--clr-grey-6);\n    border-radius: var(--radius);\n    font-size: 1rem;\n    color: var(--clr-grey-3);\n    box-sizing: border-box; \n}\n\n/* Load Practitioner by Name Button: Small Fit */\n.name-fields button {\n    padding: 0.5rem 1rem; \n    background-color: var(--clr-grey-5);\n    color: var(--clr-white);\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    transition: var(--transition);\n    font-size: 0.875rem; \n    width: auto; \n    display: inline-block; \n}\n\n.name-fields button:hover {\n    background-color: var(--clr-grey-4);\n    box-shadow: var(--light-shadow);\n}\n\n/* Remove Practitioner Button: Large Fit */\n.remove-btn {\n    padding: 0.75rem 2rem; \n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    transition: var(--transition);\n    font-size: 1rem; \n    /* width: 100%;  */\n    display: block; \n}\n\n.remove-btn:hover {\n    background-color: var(--clr-primary-4);\n    box-shadow: var(--dark-shadow);\n}\n\n/* Button container to align buttons side by side */\n.button-container {\n    display: flex;\n    justify-content: space-between;\n    gap: 1rem; \n    margin: 0 auto; \n}\n\n/* Unique class for Add Practitioner button */\n.add-practitioner-btn, .cancel-practitioner-btn {\n    padding: 0.75rem 1.5rem;\n    border-radius: 50px; \n    cursor: pointer;\n    transition: var(--transition);\n    font-size: 1rem;\n    text-align: center;\n}\n\n/* Add Practitioner button specific styles */\n.add-practitioner-btn {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    border: none;\n}\n\n.add-practitioner-btn:hover {\n    background-color: var(--clr-primary-4);\n    box-shadow: var(--dark-shadow);\n}\n\n/* Cancel button specific styles */\n.cancel-practitioner-btn {\n    background-color: var(--clr-grey-5);\n    color: var(--clr-white);\n    border: none;\n}\n\n.cancel-practitioner-btn:hover {\n    background-color: var(--clr-grey-6);\n    box-shadow: var(--dark-shadow);\n}\n\n/* Responsive styles for mobile */\n@media (max-width: 768px) {\n    .button-container {\n        flex-direction: column; \n        gap: 0.5rem;\n    }\n\n    .add-practitioner-btn, .cancel-practitioner-btn {\n        width: 100%; \n    }\n}\n\n\n/* Additional Fields for Email, Phone, and Experience */\n.updating-fields input[type=\"email\"],\n.updating-fields input[type=\"text\"],\n.updating-fields input[type=\"number\"] {  \n    width: 100%; \n    padding: 0.75rem;\n    border: 1px solid var(--clr-grey-6);\n    border-radius: var(--radius);\n    font-size: 1rem;\n    color: var(--clr-grey-3);\n    box-sizing: border-box; \n}\n\n/* Label and Input on the Same Line */\n.label-input-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 1rem;\n}\n\n.label-input-container label {\n    font-size: 1rem;\n    color: var(--clr-grey-5);\n    flex: 0.3; \n}\n\n.label-input-container input {\n    flex: 0.7; \n    padding: 0.75rem;\n    border: 1px solid var(--clr-grey-6);\n    border-radius: var(--radius);\n    font-size: 1rem;\n    color: var(--clr-grey-3);\n    box-sizing: border-box;\n}\n\n/* Error Message Styling */\n.error {\n    color: var(--red-dark);\n    font-size: 0.875rem;\n    margin-top: 0.25rem;\n}\n\n/* Field Validation */\n/* Remove red border by default until user interacts */\ninput:invalid:not(:focus):not(:placeholder-shown) {\n    border-color: var(--clr-grey-6); \n}\n\ninput:invalid:focus {\n    border-color: var(--red-dark); \n}\n\n/* input:valid {\n    border-color: var(--green-dark); \n} */\n\n/* Success Banner */\n.success-banner {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    padding: 1rem;\n    border-radius: var(--radius);\n    margin-bottom: 1rem;\n    text-align: center;\n}\n\n/* License Expiry Styling */\ninput[type=\"date\"] {\n    padding: 0.75rem;\n    border: 1px solid var(--clr-grey-6);\n    border-radius: var(--radius);\n    font-size: 1rem;\n    color: var(--clr-grey-3);\n    width: 100%; \n    box-sizing: border-box;\n}\n\n/* Responsive Success Banner */\n@media (max-width: 768px) {\n    .success-banner {\n        font-size: 0.875rem;\n    }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .practitioner-list {\n        padding: 1rem;\n    }\n\n    .practitioner-card {\n        padding: 1rem;\n        margin-bottom: 1rem;\n    }\n\n    .card-content h4 {\n        font-size: 1rem;\n    }\n\n    .card-content p {\n        font-size: 0.875rem;\n    }\n\n    .no-practitioner-card {\n        padding: 1.5rem;\n    }\n\n    .filters-section h4,\n    .updating-fields h4 {\n        font-size: 1rem;\n    }\n\n    .filters-section,\n    .updating-fields {\n        padding: 1rem;\n    }\n\n    .filters-section .name-fields,\n    .filters-section select,\n    .filters-section input,\n    .name-fields select,\n    .name-fields input {\n        padding: 0.5rem;\n        font-size: 0.875rem;\n    }\n\n    .updating-fields input[type=\"email\"],\n    .updating-fields input[type=\"text\"],\n    .updating-fields input[type=\"number\"] { \n        padding: 0.5rem;\n        font-size: 0.875rem;\n    }\n\n    .name-fields {\n        flex-direction: column; \n    }\n\n    .name-fields button {\n        font-size: 0.75rem;\n        padding: 0.5rem;\n        width: auto; \n        display: inline-block;\n    }\n\n    .remove-btn {\n        font-size: 0.875rem;\n        padding: 0.75rem;\n        width: 100%;\n        display: block;\n    }\n\n    /* Label and Input on the Same Line (Responsive) */\n    .label-input-container {\n        flex-direction: column; \n    }\n\n    .label-input-container label,\n    .label-input-container input {\n        flex: 1; \n    }\n}\n\n@media (max-width: 480px) {\n    .practitioner-grid {\n        grid-template-columns: 1fr; \n    }\n\n    .practitioner-list {\n        padding: 0.5rem;\n    }\n\n    .practitioner-card {\n        padding: 0.75rem;\n    }\n\n    .card-content h4 {\n        font-size: 0.875rem;\n    }\n\n    .card-content p {\n        font-size: 0.75rem;\n    }\n\n    .no-practitioner-card {\n        padding: 1rem;\n    }\n\n    .filters-section h4,\n    .updating-fields h4 {\n        font-size: 0.875rem;\n    }\n\n    .filters-section,\n    .updating-fields {\n        padding: 0.75rem;\n    }\n\n    .filters-section .name-fields,\n    .filters-section select,\n    .filters-section input,\n    .name-fields select,\n    .name-fields input {\n        padding: 0.5rem;\n        font-size: 0.75rem;\n    }\n\n    .updating-fields input[type=\"email\"],\n    .updating-fields input[type=\"text\"],\n    .updating-fields input[type=\"number\"] {  \n        padding: 0.5rem;\n        font-size: 0.75rem;\n    }\n\n    .name-fields button {\n        font-size: 0.75rem;\n        padding: 0.5rem;\n        width: auto;\n        display: inline-block;\n    }\n\n    .remove-btn {\n        font-size: 0.875rem;\n        padding: 0.75rem;\n        width: 100%;\n        display: block;\n    }\n}\n\n/* Banner Styles */\n.mandatory-fields-banner {\n    background-color: #fff3f3; \n    color: #d9534f; \n    padding: 5px 10px; \n    margin-bottom: 10px; \n    border: 1px solid #f2dede; \n    border-radius: 5px; \n    font-size: 0.9rem; \n}\n\n.mandatory {\n    color: #d9534f; /* Color for the asterisk */\n}\n\n/* Heading Styles */\n.add-practitioner-title {\n    font-size: 1.5rem; \n    font-weight: 600; \n    color: var(--clr-primary-4); \n    margin-bottom: 15px; \n    text-align: center; \n    border-bottom: 2px solid var(--red-light); \n    padding-bottom: 10px; \n}\n\n/* Dropdown Container */\n.dropdown-container {\n    display: flex;\n    gap: 20px; \n    justify-content: space-between;\n    flex-wrap: wrap; \n  }\n  \n  /* Style for individual dropdowns */\n  .dropdown-container select {\n    flex: 1; \n    padding: 10px; \n    border-radius: 4px;\n    border: 1px solid #ccc;\n    box-sizing: border-box; \n  }\n  \n  /* Media Query for Mobile View (Max width 768px for tablets and phones) */\n  @media (max-width: 768px) {\n    .dropdown-container {\n      flex-direction: column; \n      gap: 10px; \n    }\n  \n    .dropdown-container select {\n      width: 100%; \n    }\n  }\n  \n\n/* Input Container for the two fields */\n.input-container {\n    display: flex;\n    gap: 20px; \n    justify-content: space-between;\n    flex-wrap: wrap; \n  }\n  \n  .input-container input {\n    flex: 1; \n    padding: 10px; \n    border-radius: 4px;\n    border: 1px solid #ccc;\n    box-sizing: border-box; \n  }\n  \n  /* Media Query for Mobile View (Max width 768px) */\n  @media (max-width: 768px) {\n    .input-container {\n      flex-direction: column; \n      gap: 10px; \n    }\n  \n    .input-container input {\n      width: 100%; \n    }\n  }\n  \n\n/* Container for degree input */\n.degree-input-container {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 1.5rem;\n    border: 1px dotted var(--clr-grey-5); \n    border-radius: var(--radius); \n    padding: 1rem; \n    background-color: var(--clr-grey-10); \n}\n\n/* Wrapper for the list and input sections */\n.degree-input-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n/* Degree tags list */\n.degrees-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n    padding-bottom: 0.5rem;\n}\n\n/* Individual degree tag */\n.degree-tag {\n    background-color: var(--clr-primary-6);\n    color: var(--clr-white);\n    padding: 0.3rem;\n    border-radius: var(--radius);\n    display: inline-flex;\n    align-items: center;\n}\n\n.degree-tag button {\n    background: none;\n    border: none;\n    color: var(--clr-white);\n    cursor: pointer;\n    margin-left: 0.5rem;\n}\n\n.degree-tag button:hover {\n    color: var(--clr-primary-1);\n}\n\n/* Input and Add button section */\n.degree-input-section {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n}\n\n/* Input for entering new degrees */\n.degree-input {\n    flex-grow: 1;\n    padding: 0.75rem;\n    border: 1px solid var(--clr-grey-6);\n    border-radius: var(--radius);\n    font-size: 1rem;\n}\n\n/* Add degree button */\n.add-degree-btn {\n    padding: 0.75rem 1rem;\n    background-color: var(--clr-grey-6);\n    color: var(--clr-white);\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    transition: var(--transition);\n    font-size: 1rem;\n}\n\n.add-degree-btn:hover {\n    background-color: var(--clr-primary-4);\n    box-shadow: var(--dark-shadow);\n}\n\n/* Responsive styling */\n@media (max-width: 768px) {\n    .degree-input-section {\n        flex-direction: column; \n        gap: 0.75rem; \n    }\n\n    .add-degree-btn {\n        width: 100%; \n    }\n\n    .degree-tag {\n        font-size: 0.85rem; \n    }\n}\n\n@media (max-width: 480px) {\n    .degree-tag {\n        font-size: 0.75rem; \n        padding: 0.5rem;\n    }\n\n    .degree-input-section {\n        gap: 0.5rem; \n    }\n}\n\n.load-btn {\n    background: var(--clr-primary-6);\n    color: var(--clr-primary-1);\n    padding: 0.375rem 0.75rem;\n    font-weight: 700;\n    -webkit-transition: var(--transition);\n    transition: var(--transition);\n    font-size: 0.875rem;\n    border: 2px solid transparent;\n    cursor: pointer;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n    border-radius: var(--radius);\n\n  }\n  \n  .load-btn:hover {\n    text-decoration: underline;\n  }\n\n\n  /* Staff Add - Registration Status - Radio Buttons */\n.staff-add-registration-radio-group {\n    margin-bottom: 15px;\n}\n\n.staff-add-radio-title {\n    font-weight: bold;\n    color: #333;\n    margin-bottom: 6px;\n    display: block;\n}\n\n.staff-add-radio-options {\n    display: flex;\n    gap: 15px;\n}\n\n.staff-add-radio-label {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 1rem;\n    color: #444;\n}\n\n.staff-add-radio-label input {\n    transform: scale(1.2);\n    cursor: pointer;\n}\n\n/* Base Styling for Inputs */\n.staff-add-license-input,\n.staff-add-license-expiry,\n.staff-add-region-dropdown {\n    width: 100%;\n    padding: 8px;\n    font-size: 14px;\n    border-radius: 4px;\n    transition: all 0.3s ease-in-out;\n}\n\n/* Disabled Fields (When Not Registered) */\n.staff-add-license-input.disabled,\n.staff-add-license-expiry.disabled {\n    background-color: #f3f3f3;\n    border: 1px dashed #999;\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* Enabled Fields (When Registered) */\n.staff-add-license-input.enabled,\n.staff-add-license-expiry.enabled,\n.staff-add-region-dropdown.enabled {\n    background-color: #ffffff;\n    border: 1px solid #ccc;\n    cursor: text;\n}\n\n/* Cursor Pointer for Dropdown */\n.staff-add-region-dropdown {\n    cursor: pointer;\n}\n\n/* Helper Text */\n.staff-add-helper-text {\n    font-size: 0.9rem;\n    color: #777;\n    margin-top: 4px;\n    font-style: italic;\n}\n\n/* Reset flex overrides only for phone field */\n.label-input-container.phone-fix-override {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.35rem;\n    margin-bottom: 1rem;\n  }\n  \n  /* Phone input row with prefix and input */\n  .phone-input-split-add {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 0.5rem;\n  }\n  \n  /* Non-editable +1 prefix */\n  .phone-prefix-add {\n    background-color: #f5f5f5;\n    border: 1px solid #ccc;\n    padding: 0.5rem 0.75rem;\n    border-radius: 4px;\n    color: #333;\n    font-weight: 500;\n    min-width: 48px;\n    text-align: center;\n  }\n  \n  /* Phone input field itself */\n  .phone-input-split-add input {\n    flex: 1;\n    padding: 0.5rem;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 1rem;\n  }\n  \n  @media (max-width: 768px) {\n    .phone-input-split-add {\n      flex-direction: row; /* keep row even on mobile */\n      gap: 0.5rem;\n    }\n  \n    .phone-input-split-add input {\n      width: 100%;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
